import { render, staticRenderFns } from "./upload_button.vue?vue&type=template&id=2f788b04"
import script from "./upload_button.vue?vue&type=script&lang=js"
export * from "./upload_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports